export default "__VITE_ASSET__DuZtQFY1__"